<template>
  <div class="thankyou-container ">
    <div class="w100 padded">
      <wrap-container class="thankyou-inner-container">
        <wrap-container class="cascade w50">
          <img
            class="card"
            src="@/assets/img/ofertaNomina/cajaDeAhorro/accounts-transfer-ok.png"
            alt="Transacción Exitosa"
          />
          <p class="header">
            <strong
              >Felicitaciones <span data-obfuscate>{{ nombre }}</span
              >,</strong
            ><br />
            ¡<span data-obfuscate>{{ sexo }}</span> a BBVA!
          </p>
          <p class="titulo-detalle">Próximos pasos</p>
          <offer-group
            class="og"
            label-color="white"
            item-color="white"
            :numeric="true"
            v-on:showModal="showModal($event)"
          >
            <offer-element
              label-light="true"
              :label="
                `<strong>Recibí tus tarjetas.</strong> Nuestro servicio de mensajería te enviará un mail informándote el día de la entrega de tus tarjetas de crédito y débito en <strong><span data-obfuscate>${domicilio}</span></strong>.`
              "
              detail="Te pedimos que seas <strong>vos</strong> quien las reciba, con la <strong> última versión vigente de tu DNI a mano</strong>. La persona del correo que te visite va a sacar fotos del frente y dorso. Esto es una medida de seguridad para validar tu identidad."
            />
            <offer-element
              label-light="true"
              label="<strong>Acreditá tu sueldo en BBVA.</strong> Informale a tu empleador este número de CBU correspondiente a tu nueva cuenta sueldo. <strong>Tené en cuenta que para empezar a usar tu nueva cuenta sueldo deberás recibir primero tus tarjetas.</strong>"
              :cbu="nroCBU"
              :detail="
                `<strong>Desde el alta de tu ${nombrePaquete} te bonificamos 6 meses el costo de mantenimiento, para que puedas hacer el trámite con tu empleador</strong>`
              "
            />
            <offer-element
              label-light="true"
              :label="
                '<strong>Ingresá a banca online</strong> cuando recibas tus tarjetas de débito y crédito, para crear tu Usuario y Clave digital. '
              "
              modal="Cómo obtener mi Usuario y Clave Digital"
            />
          </offer-group>
        </wrap-container>

        <wrap-container class="cascade w50">
          <p class="titulo-detalle">¿Qué incluye tu oferta?</p>
          <p class="caja-de-ahorro">
            <span
              style='font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;'
              >Caja de ahorro en pesos y {{ nombrePaquete }}
            </span>
            con los siguientes productos:
          </p>
          <offer-group item-color="white" item-icon="azul" no-margin>
            <offer-element
              label-light="true"
              v-for="item in itemsDetalle"
              v-bind:key="item"
              :label="item"
            />
          </offer-group>
          <p>
            Te enviamos el detalle de tu solicitud <br />
            a
            <strong
              ><span data-obfuscate>{{ email }}</span></strong
            >
          </p>
          <p>
            <strong>
              Para ayudarte con el proceso de alta de tu Cuenta Sueldo:
            </strong>
          </p>
          <ul>
            <li>
              Te van a contactar telefónicamente desde BBVA.
            </li>
            <li>
              Vas a recibir un mail desde la casilla:
              <strong>cuentasueldosop-arg@bbva.com</strong> (por favor, revisá
              tu correo no deseado).
            </li>
            <li>
              También podés contactarnos al 0810-222-0000 (Opción 3) - los días
              hábiles de 9 a 15 hs.
            </li>
          </ul>
        </wrap-container>
      </wrap-container>
      <modal-clave-usuario
        v-if="showModalUsuarioClave"
        v-on:close="showModalUsuarioClave = false"
      />
      <modal-CBU v-if="showModalCBU" v-on:close="showModalCBU = false" />
    </div>
  </div>
</template>
<script>
import { byValue, provincias } from "@/config/constants";
import WrapContainer from "@/components/core/Container";
import OfferElement from "@/components/core/OfferElement";
import OfferGroup from "@/components/core/OfferGroup";
import { nombresPaquetes } from "../config/constants/packagesCodes";
import { ON_GRACIAS_GTM } from "../config/constants/mutation-types";
import ModalClaveUsuario from "@/components/core/modals/ModalClaveUsuario";
import ModalCBU from "@/components/core/modals/ModalCBU";

export default {
  name: "ThankYou",
  data() {
    return {
      showModalUsuarioClave: false,
      showModalCBU: false
    };
  },
  components: {
    WrapContainer,
    OfferElement,
    OfferGroup,
    ModalClaveUsuario,
    ModalCBU
  },
  mounted() {
    this.$store.commit(ON_GRACIAS_GTM, "paquete");
  },
  methods: {
    showModal(modal) {
      modal.includes("CBU")
        ? (this.showModalCBU = true)
        : (this.showModalUsuarioClave = true);
    }
  },
  computed: {
    beneficiosTC() {
      return this.$store.getters.getPaquetesBeneficios();
    },
    itemsDetalle() {
      return this.beneficiosTC.gracias.items;
    },
    nombre() {
      let consulta = this.$store.getters.getConsulta();
      if (consulta && consulta.nombre) {
        return consulta.nombre;
      }
      return "";
    },
    email() {
      let consulta = this.$store.getters.getConsulta();
      if (consulta && consulta.email) {
        return consulta.email;
      }
      return "";
    },
    domicilio() {
      let paso = this.$store.getters.getPaso4().domicilioParticular.calle
        ? this.$store.getters.getPaso4()
        : this.$store.getters.getConfiguracion();

      let domicilio = paso.otroDomicilio;
      if (paso.selectDomicilio === "particular") {
        domicilio = paso.domicilioParticular;
      }

      domicilio.piso = domicilio.piso ? domicilio.piso + " " : "";
      domicilio.dpto = domicilio.dpto ? domicilio.dpto + ", " : "";

      domicilio.codProvincia = domicilio.codProvincia || domicilio.provincia;
      return (
        domicilio.calle +
        " " +
        parseInt(domicilio.numero) +
        ", " +
        domicilio.piso +
        domicilio.dpto +
        domicilio.localidad +
        ", " +
        byValue(domicilio.codProvincia, provincias).label
      );
    },
    celular() {
      let consulta = this.$store.getters.getConsulta();
      if (consulta && consulta.celular) {
        return consulta.celular.area + " " + consulta.celular.numero;
      }
      return "";
    },
    sexo() {
      let consulta = this.$store.getters.getConsulta();
      if (consulta && consulta.sexo === "F") {
        return "Bienvenida";
      }
      return "Bienvenido";
    },
    nombrePaquete() {
      return nombresPaquetes(this.beneficiosTC.caracteristicas.tipoPaquete);
    },
    nroCBU() {
      return this.$store.getters.getCBUPaq();
    }
  }
};
</script>

<style scoped>
div.thankyou-container {
  color: white;
  text-align: left;
}

p.header {
  font-size: 26px;
}

p.titulo-detalle {
  font-size: 20px;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
}

.card {
  width: 151px;
  height: 113px;
}

.caja-de-ahorro {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: #ffffff;
}

.w50 {
  width: 100%;
}

@media screen and (max-width: 600px) {
  .caja-de-ahorro {
    max-width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .thankyou-inner-container {
    display: flex;
  }
  .w50:first-child {
    padding-right: 20px;
  }
  .w50:last-child {
    padding-left: 20px;
    padding-top: 122px; /* Alineación de título "próximos pasos" */
    padding-right: 50px; /* Evitar ser tapado por flotante ayuda */
  }
}

@media screen and (min-width: 1024px) {
  .og {
    width: 500px;
  }
  .caja-de-ahorro {
    width: 336px;
  }
}
</style>
